'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CatalogueCarousel = require('./components/CatalogueCarousel.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogueCarousel).default;
  }
});
Object.defineProperty(exports, 'LocalizedCatalogueCarousel', {
  enumerable: true,
  get: function get() {
    return _CatalogueCarousel.LocalizedCatalogueCarousel;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/catalogue-carousel/lib/index.js
// module id = 992
// module chunks = 3